import React, { useState, useEffect, useMemo } from 'react';
import { Link} from 'react-router-dom';
import Button from '../../components/elements/button';
// import { Search,Lab, ExportIcon } from '../../assets/icons';
import '../../assets/css/admin/cases.css';
import { casesApi } from '../../network/apis/cases';

const AdminCases = () => {
    const [searchTerm,] = useState('');
    const [cases, setCases] = useState([]);
    const [loading, setLoading] = useState(true);
    const [, setError] = useState(null);
    const [filters,] = useState({
        status: 'all',
        priority: 'all',
        lab: 'all'
    });

    // Calculate stats dynamically from fetched cases
    const stats = useMemo(() => {
        const total = cases.length;
        const pending = cases.filter(c => c.status === 'PENDING').length;
        const inProgress = cases.filter(c => ['ASSIGNED', 'IN_PROGRESS'].includes(c.status)).length;
        const completed = cases.filter(c => ['RESOLVED', 'CLOSED'].includes(c.status)).length;
        return { total, pending, inProgress, completed };
    }, [cases]);

     useEffect(() => {
                    fetchCases();
                }, []);
            
                const fetchCases = async () => {
                            try {
                                setLoading(true);
                                const response = await casesApi.getCases();
                            
                            // Handle paginated response
                            if (response.data) {
                                setCases(response.data);
                            } else {
                                setCases([]);
                            }
                        } catch (error) {
                            setError(error.message || 'Failed to fetch cases');
                            setCases([]);
                        } finally {
                            setLoading(false);
                        }
                        };

    // Filter cases based on search and filters
    const filteredCases = useMemo(() => {
        return cases.filter(caseItem => {
            const searchMatch = 
                caseItem.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                caseItem.case_code?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                caseItem.farm?.name?.toLowerCase().includes(searchTerm.toLowerCase());
            
            const statusMatch = filters.status === 'all' || 
                caseItem.status?.toLowerCase().includes(filters.status.replace('-', '_'));
            
            const priorityMatch = filters.priority === 'all' || 
                caseItem.priority?.toLowerCase() === filters.priority;
            
            return searchMatch && statusMatch && priorityMatch;
        });
    }, [cases, searchTerm, filters]);
            
    return (
        <div className="admin-cases">
            {/* <div className="page-header">
                <div className="header-content">
                    <h1>Laboratory Cases</h1>
                    <p>Manage and monitor all laboratory test cases</p>
                </div>
                <div className="header-actions">
                    <Button
                        icon={<img src={ExportIcon} alt="" />}
                        text="Export Report"
                        variant="outline"
                    />
                    <Button
                        icon={<img src={Lab} alt="" />}
                        text="Assign New Case"
                        variant="primary"
                    />
                </div>
            </div> */}

            <div className="stats-row">
                <div className="stat-card">
                    <h3>Total Cases</h3>
                    <div className="stat-value">{stats.total}</div>
                </div>
                <div className="stat-card">
                    <h3>Pending</h3>
                    <div className="stat-value warning">{stats.pending}</div>
                </div>
                <div className="stat-card">
                    <h3>In Progress</h3>
                    <div className="stat-value primary">{stats.inProgress}</div>
                </div>
                <div className="stat-card">
                    <h3>Completed</h3>
                    <div className="stat-value success">{stats.completed}</div>
                </div>
            </div>

            {/* <div className="filters-section">
                <div className="search-bar">
                    <img src={Search} alt="" />
                    <input
                        type="text"
                        placeholder="Search by farm name, case ID or lab..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>

                <div className="filters">
                    <select
                        value={filters.status}
                        onChange={(e) => setFilters({...filters, status: e.target.value})}
                    >
                        <option value="all">All Status</option>
                        <option value="pending">Pending</option>
                        <option value="in-progress">In Progress</option>
                        <option value="completed">Completed</option>
                    </select>

                    <select
                        value={filters.priority}
                        onChange={(e) => setFilters({...filters, priority: e.target.value})}
                    >
                        <option value="all">All Priority</option>
                        <option value="high">High Priority</option>
                        <option value="medium">Medium Priority</option>
                        <option value="low">Low Priority</option>
                    </select>

                    <select
                        value={filters.lab}
                        onChange={(e) => setFilters({...filters, lab: e.target.value})}
                    >
                        <option value="all">All Labs</option>
                        <option value="aqualab">AquaLab Diagnostics</option>
                        <option value="biotech">Biotech Solutions</option>
                    </select>
                </div>
            </div> */}

            <div className="cases-table">
                {loading ? (
                    <div className="loading-state">Loading cases...</div>
                ) : filteredCases.length === 0 ? (
                    <div className="empty-state">No cases found</div>
                ) : (
                <table>
                    <thead>
                        <tr>
                            <th>Case ID</th>
                            {/* <th>Farm Details</th> */}
                            <th>Title</th>
                            <th>Priority</th>
                            <th>Timeline</th>
                            <th>Status</th>
                            <th>Actions</th>
                            </tr>
                            </thead>
                            <tbody>
                                {filteredCases.map(caseItem => (
                                    <tr key={caseItem.id} onClick={() => window.location.href = `/admin/cases/${caseItem.id}`}>
                                        <td>
                                            <span className="case-id">{caseItem.case_code || `CS${caseItem.id}`}</span>
                                        </td>
                                        {/* <td>
                                            <div className="farm-details">
                                                <strong>{caseItem.farm?.name || 'N/A'}</strong>
                                                <span>{caseItem.location || caseItem.farm?.city || 'N/A'}</span>
                                            </div>
                                        </td> */}
                                <td>
                                    <div className="test-details">
                                        <span>{caseItem.title}</span>
                                        {caseItem.symptoms?.length > 0 && (
                                            <span className="samples">{caseItem.symptoms.length} symptoms</span>
                                        )}
                                    </div>
                                </td>
                                <td>
                                    <span className={`priority ${caseItem.priority?.toLowerCase()}`}>
                                        {caseItem.priority}
                                    </span>
                                </td>
                                <td>
                                    <div className="timeline">
                                        <div className="date-group">
                                            <label>Created</label>
                                            <span>{caseItem.created_at ? new Date(caseItem.created_at).toLocaleDateString() : 'N/A'}</span>
                                        </div>
                                        {caseItem.resolved_at && (
                                            <div className="date-group">
                                                <label>Last update</label>
                                                <span>{new Date(caseItem.updated_at).toLocaleDateString()}</span>
                                            </div>
                                        )}
                                    </div>
                                </td>
                                <td>
                                    {/* {caseItem.status} */}
                                    {/* <span className={`status ${caseItem.status?.toLowerCase()}`}> */}
                                    <span className={`status ${caseItem.status?.toLowerCase()}`}>
                                        {caseItem.status}
                                    </span>
                                </td>
                                <td>
                                    <div className="table-actions">
                                        <Link to={`/admin/cases/${caseItem.id}`}>
                                            <Button
                                                text="View"
                                                variant="outline"
                                                small
                                            />
                                        </Link>
                                        {/* {caseItem.status === 'PENDING' && (
                                            <Button
                                                text="Assign"
                                                variant="primary"
                                                small
                                            />
                                        )} */}
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                )}
            </div>
        </div>
    );
};

export default AdminCases;